module.exports = __webpack_public_path__ + "images/people-2-cd7a9fb675b8dc4a0947728128b1281f.jpg";